var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4941 3.99422C12.7401 2.74831 14.7599 2.74831 16.0059 3.99422C17.2088 5.19717 17.2499 7.1214 16.1299 8.3741L16.0059 8.50594L7.25586 17.2559C7.12566 17.3861 6.9569 17.4693 6.77637 17.4932L6.66699 17.5001H3.33301C2.90579 17.4999 2.55398 17.1781 2.50586 16.7637L2.5 16.6671V13.3331C2.50006 13.149 2.56116 12.9708 2.67188 12.8262L2.74414 12.7442L11.4941 3.99422ZM4.16699 13.6788V15.8321H6.32129L13.4043 8.7491L11.25 6.5948L4.16699 13.6788ZM14.8271 5.17293C14.2652 4.61097 13.374 4.5797 12.7754 5.07918L12.6729 5.17293L12.4287 5.41707L14.582 7.57039L14.8271 7.32722C15.3891 6.76529 15.4203 5.87409 14.9209 5.27547L14.8271 5.17293Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.97845d960b267560ceab6c807da70677.svg";
export { ForwardRef as ReactComponent };